<template>
  <div id="article">
    <div style="position: relative; top: 0; left: 0;">
      <div
        :style="{
          height: `${phoneSearchHeight}px`
        }"
      />
      <Banner ref="banner" :banner-cat-id="2" class="banner" />
      <MyCould />
    </div>
    <div class="article-content">
      <el-row class="article-content-box">
        <el-col
          v-show="innerWidthType !== 'xs' && innerWidthType !== 'sm'"
          :span="5"
          class="side-bar-container"
        >
          <sideBar class="side-bar" :style="{ top: `${topHeight}px` }" />
        </el-col>
        <el-col
          :xs="22"
          :sm="22"
          :md="18"
          :lg="18"
          :xl="18"
          class="content-container"
        >
          <div
            v-if="weirdTitle.indexOf(Number(this.$route.params.id)) === -1"
            class="msg"
          >
            <div class="title">
              <h1 v-text="articleData.title" />
            </div>
          </div>
          <div class="content-detaile">
            <el-col
              v-show="otherTopFont[Number(this.$route.params.id)]"
              :spna="24"
              :class="`otherFont${Number(this.$route.params.id)}`"
            >
              <div v-html="otherTopFont[Number(this.$route.params.id)]" />
            </el-col>
            <div
              v-if="otherLeftImg[Number(this.$route.params.id)]"
              class="content-detaile-right"
              :class="`content-detaile-right${Number(this.$route.params.id)}`"
            >
              <el-image
                ref="rightImg"
                :src="otherLeftImg[Number(this.$route.params.id)]"
                style="width: 100%;"
                class="rightImg"
              />
            </div>
            <div
              class="content-detaile-left"
              :class="`content-detaile-left${Number(this.$route.params.id)}`"
              :style="{
                height: imgHeight ? `${imgHeight}px` : 'auto',
                'min-height': `${imgHeight}px`,
                'padding-right': otherImg[Number(this.$route.params.id)]
                  ? '5%'
                  : '0'
              }"
            >
              <div
                v-if="weirdTitle.indexOf(Number(this.$route.params.id)) !== -1"
                class="msg"
              >
                <div class="title">
                  <h1 v-text="articleData.title" />
                </div>
              </div>
              <div v-html="articleData.content" />
            </div>
            <div
              v-if="otherImg[Number(this.$route.params.id)]"
              class="content-detaile-right"
              :class="`content-detaile-right${Number(this.$route.params.id)}`"
            >
              <el-image
                ref="rightImg"
                :src="otherImg[Number(this.$route.params.id)]"
                style="width: 100%;"
                class="rightImg"
              />
            </div>

            <el-col
              :spna="24"
              :class="`otherFont${Number(this.$route.params.id)}`"
            >
              <div v-html="otherFont[Number(this.$route.params.id)]" />
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from '@/api/service'
import sideBar from '@/components/sideBar'

export default {
  name: 'Article',
  components: {
    sideBar
  },
  data() {
    return {
      innerWidthType: '',
      id: null,
      parent_id: '',
      articleData: {},
      topHeight: 0,
      showBanner: false,
      isShowCould: false,
      imgHeight: 0,
      otherFont: {},
      otherTopFont: {},
      otherImg: {},
      otherLeftImg: {},
      phoneSearchHeight: 0,
      weirdTitle: [6, 7]
    }
  },
  watch: {
    $route(newVal) {
      const bannerTop = document.querySelector('.banner').clientHeight
      document.body.scrollTop = bannerTop
      document.documentElement.scrollTop = bannerTop
      this.imgHeight = 0
      this.getArticleContent()
    }
  },
  created() {
    this.getOtherImg()
  },
  mounted() {
    this.showBanner = true
    if (Number(this.$route.params.id) === 13) {
      this.$router.go(-1)
      // setTimeout(() => {
      //   // window.open('http://218.17.56.105:8081/', '_blank')
      //   window.open('https://rbs.wellsoon.cn', '_blank')
      // }, 550)
      return false
    }
    this.parent_id = this.$route.params.parent_id
    this.getArticleContent()
    this.getInnerWidthType()
    window.addEventListener('scroll', () => {
      this.setSideBarFix()
    })
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
      this.setSideBarFix()
    })
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.rightImg) {
          this.imgHeight = this.$refs.rightImg.$el.clientHeight
        }
      }, 1000)
    })
  },
  destroyed() {
    window.removeEventListener('scroll', () => {
      this.setSideBarFix()
    })
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
      this.setSideBarFix()
    })
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth > 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
    },
    setSideBarFix() {
      if (this.$refs.banner) {
        const bannerHeight = this.$refs.banner.$el.offsetHeight
        const bannerTop = this.$refs.banner.$el.offsetTop
        const scTop =
          document.documentElement.scrollTop || document.body.scrollTop
        const top = scTop + bannerTop
        const ofHeight =
          document.documentElement.offsetHeight || document.body.offsetHeight
        const clHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        const footerBottom = document.querySelector('#footer').clientHeight
        const sideHeight =
          document.querySelector('.side-bar-container').clientHeight -
          document.querySelector('.side-bar').clientHeight
        if (scTop > 200 && scTop < 500 && !this.isShowCould) {
          this.isShowCould = true
        }
        if (top >= bannerHeight + bannerTop) {
          this.topHeight = top - (bannerHeight + bannerTop)
        } else {
          this.topHeight = 0
        }

        if (
          sideHeight - this.topHeight < 0 &&
          footerBottom > ofHeight - scTop - clHeight
        ) {
          this.topHeight = sideHeight
        }
        if (this.$refs.rightImg) {
          this.imgHeight = this.$refs.rightImg.$el.clientHeight
        }
      }
    },
    getOtherImg() {
      API.getBannerList({ banner_cat_id: 13 }).then(res => {
        res.data.map(item => {
          this[item.remark][item.title] = item.url
        })
      })
    },
    getArticleContent() {
      this.id = Number(this.$route.params.id)
      const parms = { id: this.id, type: 1 }
      API.getArticleDate(parms)
        .then(res => {
          this.articleData = res.data
          if (this.id === 6 || this.id === 7 || this.id === 8) {
            const data = res.data.content.split('#CUT-FE40536')
            this.articleData.content = data[0]
            this.otherFont[this.id] = data[1]
          } else if (this.id === 10) {
            const data = res.data.content.split('#CUT-FE40536')
            this.otherTopFont[this.id] = data[0]
            this.articleData.content = data[1]
          }
        })
        .finally(() => {
          document.documentElement.scrollTop =
            document.documentElement.scrollTop + 1
          document.body.scrollTop = document.body.scrollTop + 1
        })
    },
    setHeight() {
      this.$parent.getHeightList()
    },
    setPhoneSearchHeight(data) {
      this.phoneSearchHeight = data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/article/xl.scss";
@media screen and (max-width: 1920px) {
  @import "@/assets/css/article/lg.scss";
}
@media screen and (max-width: 1200px) {
  @import "@/assets/css/article/md.scss";
}
@media screen and (max-width: 992px) {
  @import "@/assets/css/article/sm.scss";
}
@media screen and (max-width: 768px) {
  @import "@/assets/css/article/xs.scss";
}
</style>



// WEBPACK FOOTER //
// src/view/article.vue